__turbopack_context__.v({
  "icon": "ToolbarDropdownOptions-module__lgtI8W__icon",
  "link": "ToolbarDropdownOptions-module__lgtI8W__link",
  "list": "ToolbarDropdownOptions-module__lgtI8W__list",
  "listItem": "ToolbarDropdownOptions-module__lgtI8W__listItem",
});
